import {
  Card,
  CircularProgress,
  Divider,
  Grid,
  TextField,
} from "@mui/material";
import MDAvatar from "components/MDAvatar";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import React, { useEffect, useState } from "react";
import singhCoinCurrency from "assets/images/singhCoinCurrency.png";
import MDButton from "components/MDButton";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { claimReward } from "services/rewardService";
import { useNavigate } from "react-router-dom";

const ClaimRewards = () => {
  let navigate = useNavigate();
  const dispatch = useDispatch();

  const { userAppInfo, isLoadingInfo } = useSelector((state) => state.userInfo);

  const { balanceReward, isRewardLoading } = useSelector(
    (state) => state.userRewards
  );

  const { isWeb3Enabled, address, chainId, balance, isWalletLoading } =
    useSelector((state) => state.walletData);

  const [claimAmount, setClaimAmount] = useState("");

  const handleClaimReward = async () => {
    if (!isWeb3Enabled) {
      toast.warning(`Please connect your Metamask Wallet`, {
        style: {
          fontSize: "12px",
        },
      });
      return;
    }

    const amountClaimed = {
      amount: claimAmount,
    };

    const claimRewardRes = await claimReward(amountClaimed);
    // console.log("claimRewardRes", claimRewardRes);
    if (claimRewardRes.status === 200) {
      if (claimRewardRes.data.msg) {
        toast.warning(`${claimRewardRes.data.msg}`, {
          style: {
            fontSize: "15px",
          },
        });
      } else {
        toast.success(`${claimRewardRes.data.message}`, {
          style: {
            fontSize: "15px",
          },
        });
        navigate(`/otp`, {
          state: { amount: claimAmount, email: userAppInfo.email },
        });
        // navigate(`/otp`, { state: claimAmount });
      }
    } else {
      toast.error(`Oops!Something went wrong, please try again later`, {
        style: {
          fontSize: "15px",
        },
      });
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {!isRewardLoading && !isLoadingInfo ? (
        <Card sx={{ marginTop: "1rem", padding: "2rem" }}>
          <MDBox textAlign="center" padding="1rem">
            <MDTypography variant="h3">Claim Rewards</MDTypography>
          </MDBox>
          <Divider />
          <MDBox
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <MDBox>
              <MDTypography>Available to claim</MDTypography>
            </MDBox>
            <MDBox
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <MDAvatar
                sx={{ cursor: "pointer" }}
                //   onClick={() => handleUsernameClick(item.username)}
                size="sm"
                src={singhCoinCurrency}
                imgProps={{
                  style: {
                    height: "100%",
                    width: "100%",
                  },
                }}
              />
              <MDTypography>
                {balanceReward !== 0
                  ? Number(balanceReward).toFixed(2)
                  : balanceReward}
              </MDTypography>
            </MDBox>
          </MDBox>

          <Grid
            container
            columnGap={2}
            rowGap={2}
            justifyContent="center"
            padding="1rem"
          >
            <Grid item xs={12} md={6}>
              <TextField
                sx={{ marginBottom: "20px" }}
                onChange={(e) => {
                  setClaimAmount(e.target.value);
                }}
                fullWidth
                placeholder="Amount you want to claim"
                name="Amount"
                label="Amount"
                required
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                disabled
                sx={{ marginBottom: "20px" }}
                fullWidth
                value={userAppInfo?.email}
                name="Email"
                label="Email"
                InputLabelProps={{ shrink: true }}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <MDButton
                fullWidth
                color="singh"
                onClick={() => handleClaimReward()}
              >
                Claim
              </MDButton>
            </Grid>
          </Grid>
        </Card>
      ) : (
        <MDBox
          sx={{
            height: "500px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <MDTypography color="singh">
            <CircularProgress color="inherit" />
          </MDTypography>
        </MDBox>
      )}
    </DashboardLayout>
  );
};

export default ClaimRewards;
